
<script>

// Each Time Reload Page will access this method
// Add all init function in here
import store from '@/store/index.js'
import router from '@/router/index.js'

const authSetup = async (mainApi) =>  mainApi.post('api/auth/', {
    "username": "client",
    "password": "P@ssw0rdF0rClient"
})
    .then(response => {
        console.log(response.data.token)
        store.commit("setServerToken")
        mainApi.defaults.headers.common['Authorization'] = "Token " + response.data.token;
        mainApi.defaults.headers.common['Accept-Language'] = store.state.language;

        // Check if user still login, set API headers here
        // ** put in store will error cuz that time Axios is not created
        if(store.state.isAuthenticated === true){
            mainApi.defaults.headers.common['GL-User-ID'] = store.state.userServerID;
            mainApi.defaults.headers.common['GL-User-Online-ID'] = store.state.userOnlinePK;
            mainApi.defaults.headers.common['GL-Page-ID'] = "1";
            mainApi.defaults.headers.common['GL-Action-ID'] = "1";
        }
    })
export default authSetup
</script>
